import { Column, Text } from "@/components";

export const JobFormSection = ({
  children,
  description,
  title,
}: {
  children: React.ReactElement | React.ReactElement[];
  description: string;
  title: string;
}) => {
  return (
    <Column className="gap-6">
      <Column className="gap-1.5">
        <Text variant="header" className="text-base text-slate-900">
          {title}
        </Text>
        <Text className="text-sm font-normal leading-relaxed text-slate-400">
          {description}
        </Text>
      </Column>
      <Column className="gap-6">{children}</Column>
    </Column>
  );
};
